//@flow

import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { FormGroup, Label, Input, Row, Container, Col } from 'reactstrap';

import api from '../../lib/api';
import SEO from '../../constants/seo';
import Page from '../../components/Page';
import Loading from '../../components/Loading';
import endpoints from '../../lib/endpoints';
import { GuideCard } from '../../components/Cards';
import type { GuideData } from '../../types/cards';
import { addListingsSchema } from '../../redux/actions/schemaActions';
import { useEffectOnFirstRender } from '../../hooks';

type Props = {
  guides: Array<GuideData>,
  fetchGuides: () => void,
};

export const fetchGuideListings = () => async (dispatch, getState) => {
  const guideListingsAlreadyInStore = !isEmpty(getState().schema.guides);
  if (guideListingsAlreadyInStore) return;

  try {
    const { data } = await api.get(endpoints.profile.getGuideListings);
    dispatch(addListingsSchema(data, 'guides'));
  } catch (err) {
    console.log(err);
  }
};

const mapStateToProps = ({ schema: { guides } }) => ({
  guides,
});

const mapDispatchToProps = dispatch => ({
  fetchGuides: () => dispatch(fetchGuideListings()),
});

function GuideListings(props: Props) {
  const [searchTerm, setSearchTerm] = useState('');

  useEffectOnFirstRender(props.fetchGuides);

  if (!props.guides) return <Loading />;

  const { guides } = props;
  return (
    <Page {...SEO.guideListings}>
      <Container>
        <Row>
          <Col xl="2" lg="3" md="4" className="place-sidebar">
            <FormGroup>
              <Label for="searchTerm">Search</Label>
              <Input
                type="type"
                name="searchTerm"
                id="searchTerm"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
            </FormGroup>
          </Col>

          <Col xl="10" lg="9" md="8">
            <Row>
              {guides &&
                !isEmpty(guides) &&
                guides
                  .filter(
                    guide =>
                      `${guide.fullname}`.toUpperCase().indexOf(searchTerm.toUpperCase()) >=
                      0
                  )
                  .map(guide => (
                    <Col xl="3" lg="4" md="6" key={guide.id}>
                      <GuideCard cardData={guide} />
                    </Col>
                  ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </Page>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuideListings);



// WEBPACK FOOTER //
// ./src/screens/GuideListings/GuideListings.jsx